var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInbox = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.00001H13.3337L11.667 10.5H8.33366L6.66699 8.00001H1.66699M18.3337 8.00001V13C18.3337 13.442 18.1581 13.866 17.8455 14.1785C17.5329 14.4911 17.109 14.6667 16.667 14.6667H3.33366C2.89163 14.6667 2.46771 14.4911 2.15515 14.1785C1.84259 13.866 1.66699 13.442 1.66699 13V8.00001M18.3337 8.00001L15.4587 2.25834C15.3207 1.98067 15.108 1.74699 14.8445 1.58358C14.5809 1.42017 14.2771 1.33351 13.967 1.33334H6.03366C5.72359 1.33351 5.41971 1.42017 5.1562 1.58358C4.89268 1.74699 4.67997 1.98067 4.54199 2.25834L1.66699 8.00001",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInbox, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/inbox.38e42217.svg";
export { ForwardRef as ReactComponent };